// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1pv-A","search":"Settings_search__1DkiL","filter":"Settings_filter__2-5gH"};